var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 53,
    viewBox: "0 0 43 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1278,
    cy: 33,
    r: 21.1278,
    fill: "#DFEAEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_3146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0997 28.4463C7.20503 31.3408 5.34961 35.3373 5.34961 39.7447C5.34961 40.2645 5.77019 40.6851 6.28995 40.6851C8.33156 40.6851 9.95308 40.6851 11.9947 40.6851C12.5145 40.6851 12.935 40.2645 12.935 39.7447C12.935 37.4113 13.8841 35.2956 15.4165 33.7632L14.8374 31.3034L13.2625 29.7284L10.0997 28.4463Z",
    fill: "#EF2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3983 23.7588C21.3983 24.0665 20.458 24.3659 20.458 24.659C20.458 26.6526 20.458 28.3517 20.458 30.3414C20.458 30.6472 21.3983 30.9599 21.3983 31.2815C23.7318 31.2815 25.8475 32.2306 27.3799 33.763L28.2354 33.8479L32.173 29.9103L32.6968 28.4461C29.8022 25.5515 25.8057 23.7588 21.3983 23.7588Z",
    fill: "#17ACE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 28.4461L15.4165 33.763C16.9489 32.2306 19.0647 31.2815 21.3981 31.2815C21.3981 28.5594 21.3981 26.481 21.3981 23.7588C16.9907 23.7588 12.9942 25.5515 10.0996 28.4461Z",
    fill: "#FEDB41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6948 28.4463L27.3779 33.7632C28.9104 35.2956 29.8594 37.4113 29.8594 39.7447C29.8594 40.2645 30.28 40.6851 30.7998 40.6851C32.8414 40.6851 34.4629 40.6851 36.5045 40.6851C37.0243 40.6851 37.4449 40.2645 37.4449 39.7447C37.4449 35.3373 35.5894 31.3408 32.6948 28.4463Z",
    fill: "#10BB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6585 32.391C28.3577 32.1089 27.8875 32.0713 27.5302 32.2969C24.5775 34.1964 22.3395 35.6258 19.3868 37.5065C18.8414 37.8638 18.3901 38.334 18.1079 38.8793C17.2992 40.3275 17.5437 42.1517 18.7474 43.3366C19.9886 44.5966 21.9258 44.8036 23.4303 43.8632C24.0133 43.4682 24.5023 42.9229 24.8031 42.2646C26.2888 39.0862 27.4173 36.679 28.903 33.5006C29.0724 33.1244 28.9783 32.6731 28.6585 32.391Z",
    fill: "#495A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9017 33.5003C27.416 36.6786 26.2876 39.0859 24.8018 42.2642C24.501 42.9225 24.012 43.4679 23.429 43.8629C21.9244 44.8032 19.9873 44.5963 18.7461 43.3362L28.6572 32.3906C28.977 32.6728 29.071 33.1242 28.9017 33.5003Z",
    fill: "#42516D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_3146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.097,
    height: 32.097,
    fill: "white",
    transform: "translate(5.34961 18.0547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon2);
export default __webpack_public_path__ + "static/media/list-icon2.e7492c92b40bb66bb1223774c6180f93.svg";
export { ForwardRef as ReactComponent };